export const siteOrigin = 'https://face.sunuyoruz.biz';
export const parentSiteUrl = 'https://sunuyoruz.biz/';
